import {
  ICountryModel,
  IKeyword,
  IReviewKeyword,
} from "@/Pages/CreateCampaignPage/Models/CountryModel";
import BasicButton from "@/UI/BasicButton";
import { getDatesBetween } from "@/Utils/DateUtils";
import { throwNewToastError } from "@/Utils/MainUtils";
import {
  NewOrderImpressionsMode,
  NewOrderType,
  TNewOrderForm,
} from "@/entities/new-order";
import { useFormContext } from "react-hook-form";

interface AddNewCountryButtonProps {
  append: (value: TNewOrderForm["countriesList"][number]) => void;
}

export const AddNewCountryButton = ({ append }: AddNewCountryButtonProps) => {
  const { watch, setError } = useFormContext<TNewOrderForm>();

  const { type, dateStart, dateStop } = watch();

  const handleAddNewCountry = () => {
    if (!type) {
      throwNewToastError("Please, choose the type of order");
      setError("type", { message: "Type is required" });
      return;
    }

    if (type === NewOrderType.install_bp) {
      if (!dateStart || !dateStop) {
        throwNewToastError("Please select start and end date");
        return;
      }

      const dateArray = getDatesBetween(dateStart, dateStop);

      const newKeywords: IKeyword = {};

      dateArray.forEach((date) => {
        newKeywords[date] = { "#install_by_package#": 0 };
      });

      const newCountry: ICountryModel = { geo: null, keywords: newKeywords };
      append(newCountry);
      return;
    } else if (type === NewOrderType.install_with_views) {
      append({
        geo: null,
        keywords: {},
        impressions: {
          type: NewOrderImpressionsMode.CR,
        },
      });
    } else if (type === NewOrderType.review) {
      if (!dateStart || !dateStop) {
        throwNewToastError("Please select start and end date");
        return;
      }
      const dateArray = getDatesBetween(dateStart, dateStop);

      const newKeywords: IReviewKeyword = {};

      dateArray.forEach((date) => {
        newKeywords[date] = [];
      });
      const newCountry: ICountryModel = { geo: null, keywords: newKeywords };
      append(newCountry);
    } else {
      append({ geo: null, keywords: {} });
    }
  };

  return (
    <BasicButton
      onClick={handleAddNewCountry}
      size="md"
      text="Add country"
      variant="blue"
    />
  );
};
